<div class="tw-mx-auto tw-relative tw-isolate tw-flex tw-flex-col tw-items-center tw-self-center tw-w-full lg:tw-max-w-[976px] xl:tw-max-w-[1296px] tw-font-inter tw-mb-12 lg:tw-mb-16">
  <div class="tw-relative tw-z-10 tw-w-full lg:tw-w-max tw-px-4 lg:tw-px-0">
    <div class="tw-h-10 sm:tw-h-12 lg:tw-h-[62px] tw-w-full lg:tw-w-[552px] tw-rounded-md tw-bg-gray-200 tw-animate-pulse"></div>
  </div>

  <div class="tw-h-2 tw-w-full tw-shrink-0 tw-hidden lg:tw-block" aria-hidden="true"></div>

  <div style="height: 650px;" class="tw-relative tw-z-10 tw-w-full tw-px-4 tw-pt-2 tw-pb-0 lg:tw-p-3 lg:tw-pb-2 xl:tw-p-4 xl:tw-pb-3 lg:tw-bg-white lg:tw-border lg:tw-border-gray-200 lg:tw-rounded-2xl tw-flex tw-flex-col tw-gap-3 xl:tw-gap-4">
    <div class="tw-flex tw-items-center tw-justify-between tw-gap-3">
      <div class="tw-h-7 tw-w-40 tw-rounded tw-bg-gray-200 tw-animate-pulse"></div>
      <div class="tw-flex tw-items-center tw-gap-2">
        <div class="tw-h-8 tw-w-24 tw-rounded-md tw-bg-gray-200 tw-animate-pulse"></div>
        <div class="tw-h-8 tw-w-8 tw-rounded-full tw-bg-gray-200 tw-animate-pulse"></div>
      </div>
    </div>

    <div style="height: 577px;" class="tw-flex tw-flex-col tw-h-full lg:tw-flex-row tw-gap-2 xl:tw-gap-4">
      <div class="tw-w-full tw-h-full lg:tw-w-1/2 xl:tw-w-[624px] tw-flex tw-flex-col tw-gap-3">
        <div class="tw-h-40 sm:tw-h-48 tw-w-full tw-rounded-lg tw-bg-gray-200 tw-animate-pulse"></div>
        <div class="tw-h-4 tw-w-3/4 tw-rounded tw-bg-gray-200 tw-animate-pulse"></div>

        <div class="tw-flex tw-items-center tw-justify-between tw-gap-3">
          <div class="tw-h-4 tw-w-40 tw-rounded tw-bg-gray-200 tw-animate-pulse"></div>
          <div class="tw-h-4 tw-w-28 tw-rounded tw-bg-gray-200 tw-animate-pulse"></div>
        </div>

        <div class="tw-h-12 sm:tw-h-14 tw-w-20 sm:tw-w-24 tw-rounded-lg tw-bg-gray-200 tw-animate-pulse"></div>

        <div class="tw-h-5 tw-w-32 tw-rounded tw-bg-gray-200 tw-animate-pulse"></div>
        <div class="tw-grid tw-grid-cols-2 md:tw-grid-cols-5 tw-gap-2">
          @for (_item of [1,2,3,4,5]; track $index) {
            <div class="tw-h-14 sm:tw-h-16 tw-rounded-lg tw-bg-gray-200 tw-animate-pulse"></div>
          }
        </div>
      </div>

      <div class="tw-h-full tw-w-full lg:tw-w-1/2 xl:tw-w-[624px] tw-flex tw-flex-col tw-gap-3 tw-rounded-lg tw-border tw-border-gray-200 tw-p-3">
        <div class="tw-h-6 tw-w-44 tw-rounded tw-bg-gray-200 tw-animate-pulse"></div>
        <div class="tw-h-32 sm:tw-h-40 tw-w-4/5 tw-self-center tw-rounded-lg tw-bg-gray-200 tw-animate-pulse"></div>
        <div class="tw-h-6 tw-w-2/3 tw-self-center tw-rounded tw-bg-gray-200 tw-animate-pulse"></div>
        <div class="tw-h-4 tw-w-3/4 tw-self-center tw-rounded tw-bg-gray-200 tw-animate-pulse"></div>
        <div class="tw-h-10 tw-w-full tw-rounded-lg tw-bg-gray-200 tw-animate-pulse"></div>
      </div>
    </div>
  </div>

  <div
    class="tw-pointer-events-none tw-absolute tw-left-1/2 tw-z-0 tw-hidden tw--translate-x-1/2 tw-border-l-2 tw-border-dashed tw-border-gray-300 tw-w-0 lg:tw-block lg:tw-top-[62px] lg:tw-bottom-[-4rem]"
    aria-hidden="true"
  ></div>

  <div
    class="tw-pointer-events-none tw-absolute tw-left-8 tw-top-full tw-z-0 tw-h-16 tw-w-0 tw-border-l-2 tw-border-dashed tw-border-gray-300 lg:tw-hidden"
    aria-hidden="true"
  ></div>
</div>
